<template>
    <!-- <AlertBox v-if="$page.props.flash.success || $page.props.flash.error" :message="$page.props.flash.success || $page.props.flash.error" :type="$page.props.flash.error ? 'error' : 'success'" /> -->
    <div class="min-h-screen-ios min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 sm:bg-gray-300 text-regal-blue-900 pb-36">
       <div class="sm:mx-auto sm:w-full sm:max-w-screen-lg">
           <div class="bg-white w-full rounded-3xl">
               <div class="min-w-screen flex flex-col items-center justify-center p-8 space-y-4">
                   <div class="text-3xl font-bold tracking-tight">
                       {{ account.name }} is a {{ account.plan }} subscriber now! 🥳
                   </div>
                   <div class="text-center text-gray-800">
                       That was easy, wasn‘t it? Now pad yourself on the back — happy Paging!
                   </div>
                   <Link :href="route('explore.index')">
                        <Button label="Let's get Paging!" />
                    </Link>
                <form @submit.prevent="submit" method="POST">
                  <input type="hidden" id="session-id" name="session_id" value="" />
                  <button class="text-sm text-gray-700" type="submit">Manage your billing information</button>
                </form>
               </div>
           </div>
       </div>
   </div>

    <component :is="'script'">
        gtag('event', 'conversion', {
          'send_to': 'AW-11001193071/9lv2CJi99oIYEO_E4_0o',
          'value': {{ account.value }},
          'currency': 'USD'
        })
    </component>

</template>

<script>
    import { useForm } from '@inertiajs/inertia-vue3'
    import InlineError from '@/Shared/InlineError'
    import Button from '@/Shared/Button'
    import { ref } from 'vue'
    import { Inertia } from '@inertiajs/inertia'

    export default {
        setup(props) {
            const urlParams = new URLSearchParams(window.location.search)
            const sessionId = urlParams.get('session_id')
            const submit = () => {
                Inertia.post(route('accounts.createPortalSession'), {session_id: sessionId})
            }
            
            return {submit}
        },
        components: { Button },
        props: {
            account: Object
        },
    }
</script>
